import { useEffect, useState } from "react";
import { ShieldCheck, X, Loader2 } from "lucide-react";
import { useAuth } from "@/AuthContext";

export default function LoginModal({ open, onClose, onSuccess }) {
  const { login, error, setError } = useAuth();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) {
      setPassword("");
      setError("");
    }
  }, [open, setError]);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(password);
    setLoading(false);
    if (ok) {
      onClose?.();
      onSuccess?.();
    }
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm px-4"
      data-testid="login-modal-backdrop"
      onClick={onClose}
    >
      <div
        className="card w-full max-w-md p-7 relative border-yellow-400/30"
        data-testid="login-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-4 right-4 text-neutral-500 hover:text-white"
          onClick={onClose}
          data-testid="login-modal-close"
          aria-label="Fechar"
        >
          <X size={18} />
        </button>
        <div className="flex items-center gap-3 mb-5">
          <div className="w-10 h-10 rounded-full bg-yellow-400/15 border border-yellow-400/40 flex items-center justify-center">
            <ShieldCheck size={20} className="text-yellow-400" />
          </div>
          <div>
            <h3 className="font-display text-xl uppercase tracking-tight">
              Área Reservada
            </h3>
            <p className="text-xs text-neutral-400">
              Acesso exclusivo do Personal Trainer
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="overline block mb-2" htmlFor="login-password">
              Password
            </label>
            <input
              id="login-password"
              type="password"
              autoFocus
              autoComplete="current-password"
              className="input w-full"
              placeholder="Introduz a password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password-input"
              required
            />
          </div>

          {error ? (
            <div
              className="text-sm text-yellow-300 bg-yellow-400/10 border border-yellow-400/30 px-3 py-2 rounded"
              data-testid="login-error"
            >
              {error}
            </div>
          ) : null}

          <button
            type="submit"
            disabled={loading || !password}
            className="btn-primary w-full inline-flex items-center justify-center gap-2"
            data-testid="login-submit-btn"
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : null}
            {loading ? "A entrar..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
